(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-gallery"]) return;
  try {
    
  (() => {
    if (window.__dcGalleryBound) return;
    window.__dcGalleryBound = true;

    const buildLightbox = () => {
      const box = document.createElement('div');
      box.className = 'glb';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-label', 'Gallery image viewer');
      box.innerHTML =
        '<button class="glb__close" aria-label="Close" type="button">&#10005;</button>' +
        '<button class="glb__nav glb__nav--prev" aria-label="Previous image" type="button">&#8249;</button>' +
        '<img alt="">' +
        '<button class="glb__nav glb__nav--next" aria-label="Next image" type="button">&#8250;</button>';
      document.body.appendChild(box);
      return {
        box,
        img: box.querySelector('img'),
        close: box.querySelector('.glb__close'),
        prev: box.querySelector('.glb__nav--prev'),
        next: box.querySelector('.glb__nav--next')
      };
    };

    const lb = buildLightbox();
    let items = [], idx = 0, lastFocus = null;

    function show(i) {
      idx = (i + items.length) % items.length;
      lb.img.src = items[idx].dataset.galleryFull;
      lb.img.alt = items[idx].querySelector('img')?.alt || 'DivaChic gallery';
      lb.prev.disabled = items.length < 2;
      lb.next.disabled = items.length < 2;
    }
    function open(item) {
      const wall = item.closest('[data-gallery]');
      items = [...wall.querySelectorAll('[data-gallery-full]')];
      if (!items.length) return;
      lastFocus = document.activeElement;
      show(items.indexOf(item));
      lb.box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lb.close.focus();
    }
    function closeLb() {
      lb.box.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', e => {
      const item = e.target.closest('[data-gallery-full]');
      if (item) { open(item); return; }
      if (e.target.closest('.glb__close') || e.target === lb.box) { closeLb(); return; }
      if (e.target.closest('.glb__nav--prev')) { show(idx - 1); return; }
      if (e.target.closest('.glb__nav--next')) { show(idx + 1); return; }
    });

    document.addEventListener('keydown', e => {
      if (!lb.box.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
